interface IMenuItems {
  path: string;
  label: string;
  name: string;
  hasSubMenu: boolean;
  menuKey: number;
  subMenuKey?: number;
  isSubMenu?: boolean;
  permission?: string;
}

export const MenuItems: IMenuItems[] = [
  // {
  //   label: "ניהול הדפסות",
  //   name: "RFIDTickets",
  //   path: "/",
  //   hasSubMenu: false,
  //   menuKey: 1,
  //   isSubMenu: false,
  //   permission: "ADMIN",
  // },
  // {
  //   path: "/printsArchive",
  //   label: "ארכיון הדפסות",
  //   name: "printsArchive",
  //   hasSubMenu: false,
  //   menuKey: 1,
  //   isSubMenu: false,
  //   permission: "ADMIN",
  // },
  {
    path: "/TicketsCompare",
    label: "menu.ticketsCompare",
    name: "TicketsCompare",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "ADMIN",
  },
  {
    path: "/TicketsCompare",
    label: "menu.ticketsCompare",
    name: "TicketsCompare",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "DBU",
  },
  {
    path: "/Errors",
    label: "menu.errors",
    name: "errors",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "ADMIN",
  },
  {
    path: "/newClub",
    label: "menu.newClub",
    name: "newClub",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "ADMIN",
  },
  {
    path: "/RenewSeason",
    label: "menu.renewSeason",
    name: "RenewSeason",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "ADMIN",
  },
  {
    path: "/sendEmail",
    label: "menu.sendEmail",
    name: "SendEmail",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "EmailTicket",
  },
  {
    path: "/Concert",
    label: "menu.concert",
    name: "Concert",
    hasSubMenu: false,
    menuKey: 1,
    isSubMenu: false,
    permission: "ConcertWhatsapp",
  },
  // {
  //     label:"printers",
  //     name:"printers",
  //     hasSubMenu:false,
  //     menuKey:1,
  //     path: "/printers",
  //     isSubMenu:false,

  // },
  // {
  //     label: "מכירת כרטיס יחיד",
  //     name: "oneTicketSale",
  //     hasSubMenu: false,
  //     menuKey: 1,
  //     path: "/",
  //     isSubMenu: false,

  // },
  // {
  //     label: "מכירת כרטיס עונתי",
  //     name: "SeasonTicketSale",
  //     hasSubMenu: false,
  //     menuKey: 1,
  //     path: "/",
  //     isSubMenu: false,

  // },
  // {
  //     path: "/",
  //     label: "ממשק ניהול",
  //     name: "managementInterface",
  //     hasSubMenu: true,
  //     subMenuKey: 2,
  //     menuKey: 1,
  //     isSubMenu: false,

  // },
  // {
  //     path: "/",
  //     label: "תרחישים ותגובות",
  //     name: "ScenariosAndResponses",
  //     hasSubMenu: false,
  //     menuKey: 1,
  //     isSubMenu: false,
  // },
  // {
  //     path: "/",
  //     label: "ניהול הדפסות",
  //     name: "printManagement",
  //     hasSubMenu: false,
  //     isSubMenu: true,
  //     menuKey: 2
  // },
];
